<template>
  <div>
    <div class="xl:pt-6">
      <div
        class="hidden h-[20vw] w-full grid-cols-[repeat(5,20vw)] text-avu-black min-[900px]:grid"
      >
        <LetterSvgGroup
          :class="'flex h-full w-full items-center justify-center py-[31px] [&:nth-child(2)]:bg-avu-blue [&:nth-child(3)]:bg-avu-pink'"
        />
      </div>

      <DynamicTextBlock
        v-if="dynamicBlock"
        class="max-[900px]:hidden"
        :dynamic-value="dynamicBlock"
      />

      <!-- Design for screens less than 900px -->
      <div
        class="grid w-full grid-cols-3 grid-rows-[repeat(4,30vw)] text-avu-black min-[900px]:hidden"
      >
        <LetterSvgGroup
          :class="`flex h-full w-full items-center justify-center py-3.5 first:col-span-1 first:bg-avu-blue [&:nth-child(2)]:bg-avu-blue [&:nth-child(3)]:col-start-2 [&:nth-child(3)]:row-start-2 [&:nth-child(3)]:bg-avu-pink [&:nth-child(4)]:col-start-3 [&:nth-child(4)]:row-start-2 [&:nth-child(4)]:bg-avu-pink [&:nth-child(5)]:col-start-1 [&:nth-child(5)]:row-start-3 [&:nth-child(5)]:bg-avu-blue`"
        />

        <DynamicTextBlock
          :dynamic-value="dynamicBlock"
          class="col-span-2 col-start-2 row-start-3"
        />

        <div class="col-span-2 col-start-2 row-start-4 bg-avu-pink" />
      </div>
    </div>

    <NewsSection :news="news" />

    <AboutSection
      :about-title="aboutTitle"
      :about-content="aboutContent"
      :research-title="researchTitle"
      :research-content="researchContent"
    />
  </div>
</template>

<script setup>

  const staticPage = ref(null);
  const news = ref(null);
  const dynamicBlock = ref(null);

  const aboutTitle = computed(() => staticPage.value?.about_us?.title || "");
  const aboutContent = computed(
    () => staticPage.value?.about_us?.content || ""
  );
  const researchTitle = computed(() => staticPage.value?.research?.title || "");
  const researchContent = computed(
    () => staticPage.value?.research?.content || ""
  );

  const { data: queryData } = await usePersistedFetch("homePage");

  onMounted(() => {
    definePageMeta({
      layout: "home",
    });
  });

  watchEffect(() => {
    staticPage.value = queryData.value?.settings?.static_pages.homepage;
    news.value = queryData.value?.publications;
    dynamicBlock.value = queryData.value?.settings?.header;
  });
</script>